import React from "react";
import _ from "lodash";
import Functions from "./Functions";
import { selectedPolygonTypes, Tenant, polygonStartString } from "./Constants";
import pick from "lodash/pick";
import { Switch } from "antd";
import { havePermission } from "../../permissions";
import LAYER_PERMISSIONS from "../../permissions/Layers.json";
const { Error, getLegend } = Functions;
const { BAT_UK, BAT_UK_INDEPENDENT, BAT_GERMANY } = Tenant;
const {
	SAWhiteSpace,
	Expansion,
	whiteSpace,
	categoryWhiteSpace,
	CategoryExpansion,
	CategorySAWhiteSpace,
	CategoryExpansionCore
} = selectedPolygonTypes;
const COVERED = "#4AF25A";
const EMPTY = "#D3D3D3";
const SA_COVERED = "#FF88A1";
const TRANSPARENT = "#FFFFFF11";
const whiteSpaceColor = ["#0091ea", "#84ffff"];
// const noTenantShops = "#FF88A1";
// const tenatMorethenCensus = "#d9cdcc";
const getFlag = {
	COVERED: "COVERED",
	NEARBY: "UN COVERED",
	EMPTY: "UN COVERED",
	"UN COVERED": "UN COVERED",
	"CENSUS COVERED": "SA CENSUS",
	"SA CENSUS": "SA CENSUS"
};

const rangesAndColors = {
	Expansions: {
		ranges: [
			{ min: 0, max: 20, color: "#C2DCFF" },
			{ min: 21, max: 40, color: "#70AEFF" },
			{ min: 41, max: 60, color: "#338BFF" },
			{ min: 61, max: 80, color: "#0058CC" },
			{ min: 81, max: 100, color: "#00357A" }
		],
		SliderRange: { min: 0, max: 100 }
	},
	[SAWhiteSpace]: {
		ranges: [
			{ min: 0, max: 20, color: "#B6E7A8" }, // Light green
			{ min: 21, max: 40, color: "#8EDD65" }, // Medium light green
			{ min: 41, max: 60, color: "#5CBF00" }, // Medium green
			{ min: 61, max: 80, color: "#3F8C00" }, // Dark green
			{ min: 81, max: 100, color: "#1F4D00" } // Darker green
		],
		SliderRange: { min: 0, max: 100 }
	}
};

const getColor = (value, ranges) => {
	let FoundedRange = ranges.find(item => {
		return value >= item.min && value <= item.max;
	});
	return { FoundedRange };
};
const WHITESPASCECOLOR = {
	COVERED: COVERED,
	"UN COVERED": EMPTY,
	"SA CENSUS": SA_COVERED
};
const getWhiteSpaceSliderRange = ({ analysisData }) => {
	let {
		data: {
			ranges: {
				population: { max, min }
			}
		}
	} = analysisData;
	let WhiteSpaceSliderRange = { min, max };
	return WhiteSpaceSliderRange;
};
const buildWhiteSpacePolygons = ({ locations, range, filter, type }) => {
	try {
		const key = polygonStartString[`${type}`] || type;

		let WhiteSpacePolygons = {};
		let listData = [];
		let graphData = {};
		let ranges = rangesAndColors.Expansions.ranges;

		for (let key of Object.keys(WHITESPASCECOLOR))
			graphData[key] = {
				color: WHITESPASCECOLOR[key],
				type: key,
				value: 0
			};

		for (let [ind, obj] of locations.entries()) {
			let { data, boundary } = obj;
			let { flag, population, stores, census_store, customer_stores } = data;
			const tenentStores = stores !== undefined ? stores : customer_stores;
			flag = getFlag[flag.trim().toUpperCase()];
			let fillColor = TRANSPARENT;
			population = Math.floor(population);
			let FilterValue = undefined;
			FilterValue = flag;
			if (_.isEmpty(range)) {
				if (type === SAWhiteSpace) {
					if (tenentStores) {
						FilterValue = ((census_store - tenentStores) / tenentStores) * 100;
						FilterValue > 100 && (FilterValue = 100);
						FilterValue < 0 && (FilterValue = 0);

						FilterValue = Math.floor(FilterValue);
						let ranges = rangesAndColors[SAWhiteSpace].ranges;
						let { FoundedRange } = getColor(FilterValue, ranges);
						const { color } = FoundedRange;
						fillColor = color;
					} else {
						FilterValue = 100;
						fillColor = "#1F4D00";
					}
				} else if (type === Expansion || type === CategoryExpansion) {
					FilterValue = Math.floor(tenentStores < census_store ? (tenentStores / census_store) * 100 : 0);
					let { FoundedRange } = getColor(FilterValue, ranges);
					const { color } = FoundedRange;
					fillColor = color;
				} else if (type === CategoryExpansionCore) {
					if (tenentStores) {
						FilterValue = ((census_store - tenentStores) / tenentStores) * 100;
						FilterValue > 100 && (FilterValue = 100);
						FilterValue < 0 && (FilterValue = 0);

						FilterValue = Math.floor(FilterValue);

						let ranges = rangesAndColors[SAWhiteSpace].ranges;
						let { FoundedRange } = getColor(FilterValue, ranges);
						const { color } = FoundedRange;
						fillColor = color;
					} else {
						FilterValue = 100;
						fillColor = "#1F4D00";
					}
				} else {
					fillColor = WHITESPASCECOLOR[flag];
				}
			} else {
				if (population >= range.min && population <= range.max)
					fillColor = WHITESPASCECOLOR[flag] ?? TRANSPARENT;
				else {
					fillColor = TRANSPARENT;
				}
			}

			if (!_.isEmpty(filter) && fillColor !== TRANSPARENT && filter !== flag) fillColor = TRANSPARENT;
			let polygon = {
				id: `${key}-${ind}`,
				coordinates: boundary.polygon,
				style: { fillColor, strokeColor: "#00000055", zIndex: 5 },
				showInfo:
					type === SAWhiteSpace ||
					type === Expansion ||
					type === CategorySAWhiteSpace ||
					type === CategoryExpansion
						? census_store > tenentStores && tenentStores !== 0
						: false,
				filterData: {
					...{
						value: FilterValue
					}
				},
				data: {
					census_store: data.census_store || 0,
					stores: tenentStores || 0
				}
			};
			WhiteSpacePolygons[`${key}-${ind}`] = polygon;
		}

		return { polygons: WhiteSpacePolygons, listData, graphData: Object.values(graphData) };
	} catch (e) {
		console.error(e);
		Error("Error While Building WhiteSpace Polygons");
	}
};

const LegendMapping = {
	COVERED: "Completely Covered",
	"UN COVERED": "Whitespace",
	"SA CENSUS": "Partially Covered"
};

const getWhiteSpaceLegends = ({ legendHandler, type, tenant }) => {
	const whiteSpaceCategoryPermission = havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_WHITE_SPACE);
	let legends = [];

	if (type === categoryWhiteSpace) {
		if (havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_WHITE_SPACE_LEGEND))
			for (let key of Object.keys(WHITESPASCECOLOR))
				legends.push(
					getLegend({
						text: LegendMapping[key],
						color: WHITESPASCECOLOR[key],
						onClick: () => legendHandler(key)
					})
				);
		legendHandler;
		if (whiteSpaceCategoryPermission && [BAT_UK, BAT_UK_INDEPENDENT].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>Selected Universe</h6>

					<Switch
						key={"CoreUniverseSwitch2"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === categoryWhiteSpace ? whiteSpace : categoryWhiteSpace)}
					/>
					<h6 style={{ paddingRight: 5 }}>Core Universe</h6>
				</span>
			);

		if (whiteSpaceCategoryPermission && [BAT_GERMANY].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>All Types</h6>

					<Switch
						key={"CoreUniverseSwitch2"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === categoryWhiteSpace ? whiteSpace : categoryWhiteSpace)}
					/>
					<h6 style={{ paddingRight: 5 }}>Relevent types</h6>
				</span>
			);

		return { legends };
	}
	if (type === whiteSpace) {
		if (havePermission(LAYER_PERMISSIONS.LAYER_WHITE_SPACE_LEGEND)) {
			for (let key of Object.keys(WHITESPASCECOLOR))
				legends.push(
					getLegend({
						text: LegendMapping[key],
						color: WHITESPASCECOLOR[key],
						onClick: () => legendHandler(key)
					})
				);
		}

		if (whiteSpaceCategoryPermission && [BAT_UK, BAT_UK_INDEPENDENT].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>Selected Universe</h6>

					<Switch
						key={"CoreUniverseSwitch2"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === categoryWhiteSpace ? whiteSpace : categoryWhiteSpace)}
					/>
					<h6 style={{ paddingRight: 5 }}>Core Universe</h6>
				</span>
			);
		if (whiteSpaceCategoryPermission && [BAT_GERMANY].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>All Types</h6>

					<Switch
						key={"CoreUniverseSwitch2"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === categoryWhiteSpace ? whiteSpace : categoryWhiteSpace)}
					/>
					<h6 style={{ paddingRight: 5 }}>Relevent types</h6>
				</span>
			);

		return { legends };
	}

	const comparisonCategoryPermission = havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_COMPARISON_WHITE_SPACE);

	if (type === Expansion) {
		let { ranges } = rangesAndColors.Expansions;

		if (havePermission(LAYER_PERMISSIONS.LAYER_COMPARISON_WHITE_SPACE_LEGEND))
			ranges.forEach(item => {
				legends.push(getLegend({ color: item.color, text: `${item.min} - ${item.max}` }));
			});

		if (comparisonCategoryPermission && [BAT_UK, BAT_UK_INDEPENDENT].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>Selected Universe</h6>
					<Switch
						key={"CoreUniverseSwitch1"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === CategoryExpansion ? SAWhiteSpace : CategorySAWhiteSpace)}
					/>
					<h6 style={{ paddingLeft: 5 }}> Core Universe</h6>
				</span>
			);

		if (comparisonCategoryPermission && [BAT_GERMANY].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>All Types</h6>
					<Switch
						key={"CoreUniverseSwitch1"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === CategoryExpansion ? SAWhiteSpace : CategorySAWhiteSpace)}
					/>
					<h6 style={{ paddingLeft: 5 }}>Relevent types </h6>
				</span>
			);

		if (havePermission(LAYER_PERMISSIONS.LAYER_EXAPNSOIN_WHITE_SPACE))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<Switch
						checked={true}
						checkedChildren="Coverage"
						unCheckedChildren="Compassion"
						onClick={() => legendHandler(Expansion)}
					/>
				</span>
			);

		return { legends };
	}

	if (type === CategoryExpansion) {
		let { ranges } = rangesAndColors.Expansions;
		if (havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_COMPARISON_WHITE_SPACE_LEGEND))
			ranges.forEach(item => {
				legends.push(getLegend({ color: item.color, text: `${item.min} - ${item.max}` }));
			});

		if (comparisonCategoryPermission && [BAT_UK, BAT_UK_INDEPENDENT].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>Selected Universe</h6>
					<Switch
						key={"CoreUniverseSwitch1"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === CategoryExpansion ? SAWhiteSpace : CategorySAWhiteSpace)}
					/>
					<h6 style={{ paddingLeft: 5 }}> Core Universe</h6>
				</span>
			);

		if (comparisonCategoryPermission && [BAT_GERMANY].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>All Types</h6>
					<Switch
						key={"CoreUniverseSwitch1"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => legendHandler(type === CategoryExpansion ? SAWhiteSpace : CategorySAWhiteSpace)}
					/>
					<h6 style={{ paddingLeft: 5 }}>Relevent types </h6>
				</span>
			);
		if (havePermission(LAYER_PERMISSIONS.LAYER_EXAPNSOIN_WHITE_SPACE))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<Switch
						checked={true}
						checkedChildren="Coverage"
						unCheckedChildren="Compassion"
						onClick={() => legendHandler(Expansion)}
					/>
				</span>
			);
		return { legends };
	}

	const expansionCategoryPermission = havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_EXPANSION_WHITE_SPACE);
	if (type === SAWhiteSpace) {
		let { ranges } = rangesAndColors[SAWhiteSpace];
		if (havePermission(LAYER_PERMISSIONS.LAYER_EXAPNSOIN_WHITE_SPACE_LEGEND))
			ranges.forEach(item => {
				legends.push(getLegend({ color: item.color, text: `${item.min} - ${item.max}` }));
			});

		if (expansionCategoryPermission && [BAT_UK, BAT_UK_INDEPENDENT].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>Selected Universe</h6>
					<Switch
						key={"CoreUniverseSwitch"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => {
							legendHandler(type === SAWhiteSpace ? CategoryExpansionCore : Expansion);
						}}
					/>
					<h6 style={{ paddingLeft: 5 }}> Core Universe</h6>
				</span>
			);

		if (havePermission(LAYER_PERMISSIONS.LAYER_EXAPNSOIN_WHITE_SPACE))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<Switch
						key={`UniverseSwitch-${type}`}
						checkedChildren=""
						unCheckedChildren="Expansion Opportunity"
						onClick={() => legendHandler(SAWhiteSpace)}
					/>
				</span>
			);

		return { legends };
	}

	if (type === CategoryExpansionCore) {
		let { ranges } = rangesAndColors[SAWhiteSpace];
		if (havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_EXPANSION_WHITE_SPACE_LEGEND))
			ranges.forEach(item => {
				legends.push(getLegend({ color: item.color, text: `${item.min} - ${item.max}` }));
			});

		if (expansionCategoryPermission && [BAT_UK, BAT_UK_INDEPENDENT].includes(tenant))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<h6 style={{ paddingRight: 5 }}>Selected Universe</h6>
					<Switch
						key={"CoreUniverseSwitch"}
						checkedChildren=""
						unCheckedChildren=""
						onClick={() => {
							legendHandler(type === SAWhiteSpace ? CategoryExpansionCore : Expansion);
						}}
					/>
					<h6 style={{ paddingLeft: 5 }}> Core Universe</h6>
				</span>
			);

		if (havePermission(LAYER_PERMISSIONS.LAYER_EXAPNSOIN_WHITE_SPACE))
			legends.push(
				<span
					style={{
						width: "max-content",
						"font-size": "11px",
						padding: "2px 4px",
						margin: "2px 3px 0px",
						display: "inline-flex",
						"align-items": "center"
					}}
				>
					<Switch
						key={`UniverseSwitch-${type}`}
						checkedChildren=""
						unCheckedChildren="Expansion Opportunity"
						onClick={() => legendHandler(SAWhiteSpace)}
					/>
				</span>
			);

		return { legends };
	}

	return { legends };
};

const getWhiteSpaceSlider = ({ sliderHandler, type }) => {
	// let SliderRange = getWhiteSpaceSliderRange({ analysisData });
	let SliderRange = { min: 0, max: 100 };

	let { min, max } = SliderRange;
	const slider = {
		min,
		max,
		sliderHandler,
		type: type
	};
	if (type === Expansion) {
		if (havePermission(LAYER_PERMISSIONS.LAYER_COMPARISON_WHITE_SPACE_SLIDER)) {
			return slider;
		}
	}

	if (type === CategoryExpansion) {
		if (havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_COMPARISON_WHITE_SPACE_SLIDER)) {
			return slider;
		}
	}

	if (type === SAWhiteSpace) {
		if (havePermission(LAYER_PERMISSIONS.LAYER_EXAPNSOIN_WHITE_SPACE_SLIDER)) {
			return slider;
		}
	}

	if (type === CategoryExpansionCore) {
		if (havePermission(LAYER_PERMISSIONS.LAYER_CATEGORY_EXPANSION_WHITE_SPACE_SLIDER)) {
			return slider;
		}
	}
	return null;
};

const WhiteSpace = {
	all: ({ locations, filter, range, legendHandler, type, sliderHandler, cellSite, tenant }) => {
		return {
			...pick(buildWhiteSpacePolygons({ locations, range, filter, type, cellSite }), ["polygons"]),
			...getWhiteSpaceLegends({ legendHandler, type, cellSite, tenant }),
			...{ slider: getWhiteSpaceSlider({ sliderHandler, type }) }
		};
	},
	polygons: ({ locations, range, filter, cellSite }) => {
		return {
			...pick(buildWhiteSpacePolygons({ locations, range, filter, cellSite }), ["polygons"])
		};
	},
	listData: ({ analysisData, range, filter }) => {
		return {
			...pick(buildWhiteSpacePolygons({ analysisData, range, filter }), ["listData"])
		};
	},
	graph: ({ analysisData, range, filter }) => {
		return {
			...pick(buildWhiteSpacePolygons({ analysisData, range, filter }), ["graphData"]),
			graphType: "PieChart"
		};
	},
	getColor,
	rangesAndColors
};
export default WhiteSpace;

export {
	buildWhiteSpacePolygons,
	getWhiteSpaceSlider,
	getWhiteSpaceLegends,
	getWhiteSpaceSliderRange,
	whiteSpaceColor
};
